import { prefersReducedMotion } from './prefersReducedMotion.js';

/**
 * Scroll-scrubbed vertical drift with a configurable direction. Reads
 * `data-direction="up"` or `"down"` on the element (defaults to "down").
 * Animates `yPercent` symmetrically around 0 so two opposed instances feel
 * balanced — used for the parallax-hero section's top/bottom chip clusters.
 *
 * Optional `data-amount` (default 4) tunes the percentage range (±amount%).
 *
 * Trigger: the element itself. Active while the element is in the viewport
 * (`top bottom` → `bottom top`), so a small absolutely-positioned cluster
 * inside a section drifts the whole time its section is on-screen.
 */
export default (direction = 'up', amount = 4) => ({
  amount: amount || 4,
  direction: direction === 'up' ? 'up' : 'down',
  init() {
    if (prefersReducedMotion()) return;
    const sign = this.direction === 'up' ? -1 : 1;

    window.gsap.fromTo(
      this.$el,
      { yPercent: -this.amount * sign },
      {
        yPercent: this.amount * sign,
        ease: 'none',
        scrollTrigger: {
          trigger: this.$el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  },
});
